import app from '@/main.js'

async function messageReactionsMarkAsRead ({ userId, reactionUnreadSince = null }) {
  return await app.wsp.sendRequest({
    data: {
      userId: userId,
      reactionUnreadSince: reactionUnreadSince
    },
    method: 'messageReactions.markAsRead'
  })
}

export default messageReactionsMarkAsRead